export const consentAnswerOptions = [
  {
    label: 'Yes',
    value: 'yes',
  },
  {
    label: 'No',
    value: 'no',
  },
  {
    label: 'Not appropriate (person lacks capacity)',
    value: 'not_appropriate_lacks_capacity',
  },
  {
    label: 'Not appropriate (other reason)',
    value: 'not_appropriate_other_reason',
  },
] as const;

export type ConsentAnswer = (typeof consentAnswerOptions)[number]['value'] | '';

export interface VoiceTranscribingConsentForm {
  understandsStatement: ConsentAnswer;
  happyForTranscribingService: ConsentAnswer;
  otherReason: string;
}
